module.exports = __webpack_public_path__ + "1a247be1588e3f9be90c5e0084ec51d7.pdf";